module.exports = __webpack_public_path__ + "49dedd90d016a61f419f7ac4bde46fbb.svg";